/**
 * Remove diacritics (see https://en.wikipedia.org/wiki/Diacritic) from a string.
 * @param str
 * @returns
 */
export const removeDiacritics = (str: string) =>
  // See https://stackoverflow.com/a/37511463
  str.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
